__turbopack_context__.v({
  "address": "BoutiqueInfo-module-scss-module__aS67Aq__address",
  "addressLine": "BoutiqueInfo-module-scss-module__aS67Aq__addressLine",
  "column": "BoutiqueInfo-module-scss-module__aS67Aq__column",
  "columnTitle": "BoutiqueInfo-module-scss-module__aS67Aq__columnTitle",
  "columns": "BoutiqueInfo-module-scss-module__aS67Aq__columns",
  "contact": "BoutiqueInfo-module-scss-module__aS67Aq__contact",
  "contactLabel": "BoutiqueInfo-module-scss-module__aS67Aq__contactLabel",
  "contactLine": "BoutiqueInfo-module-scss-module__aS67Aq__contactLine",
  "contactLink": "BoutiqueInfo-module-scss-module__aS67Aq__contactLink",
  "ctaButton": "BoutiqueInfo-module-scss-module__aS67Aq__ctaButton",
  "ctaWrap": "BoutiqueInfo-module-scss-module__aS67Aq__ctaWrap",
  "hoursFallback": "BoutiqueInfo-module-scss-module__aS67Aq__hoursFallback",
  "hoursList": "BoutiqueInfo-module-scss-module__aS67Aq__hoursList",
  "hoursRow": "BoutiqueInfo-module-scss-module__aS67Aq__hoursRow",
  "hoursValue": "BoutiqueInfo-module-scss-module__aS67Aq__hoursValue",
  "linkIcon": "BoutiqueInfo-module-scss-module__aS67Aq__linkIcon",
  "section": "BoutiqueInfo-module-scss-module__aS67Aq__section",
  "serviceIcon": "BoutiqueInfo-module-scss-module__aS67Aq__serviceIcon",
  "serviceItem": "BoutiqueInfo-module-scss-module__aS67Aq__serviceItem",
  "serviceLabel": "BoutiqueInfo-module-scss-module__aS67Aq__serviceLabel",
  "servicesGrid": "BoutiqueInfo-module-scss-module__aS67Aq__servicesGrid",
  "servicesSection": "BoutiqueInfo-module-scss-module__aS67Aq__servicesSection",
  "statusDot": "BoutiqueInfo-module-scss-module__aS67Aq__statusDot",
  "statusDot_closed": "BoutiqueInfo-module-scss-module__aS67Aq__statusDot_closed",
  "statusDot_open": "BoutiqueInfo-module-scss-module__aS67Aq__statusDot_open",
  "statusDot_temporary": "BoutiqueInfo-module-scss-module__aS67Aq__statusDot_temporary",
  "statusRow": "BoutiqueInfo-module-scss-module__aS67Aq__statusRow",
  "statusText": "BoutiqueInfo-module-scss-module__aS67Aq__statusText",
  "statusText_open": "BoutiqueInfo-module-scss-module__aS67Aq__statusText_open",
  "textLink": "BoutiqueInfo-module-scss-module__aS67Aq__textLink",
  "visuallyHidden": "BoutiqueInfo-module-scss-module__aS67Aq__visuallyHidden",
  "weekday": "BoutiqueInfo-module-scss-module__aS67Aq__weekday",
});
